export default class PlaybookAction {
    constructor(properties, playbook) {
        this.playbook = playbook;
        _.merge(this, PlaybookAction.defaults(), properties);
    }

    static defaults() {
        return {};
    }

    valid() {
        if (!this.type_id) {
            return false;
        }
        if (!this.name) {
            return false;
        }
        if (!hasValue(this.trigger_id)) {
            return false;
        }
        if (!hasValue(this.delay_days)) {
            return false;
        }
        switch (this.type_id) {
            case 1: //TASK
                break;
            case 2: // MESSAGE
                if (!this.message_template_id) {
                    return false;
                }
                if (
                    this.playbook.entity_type_id == 1 &&
                    !this.message_recipient_tag_id
                ) {
                    return false;
                }
                break;
            case 3: // TYPE_REASSIGN
                return false;
                break;
            case 4: // TYPE_WEBHOOK
                return false;
                break;
            case 5: // TYPE_CALL
                break;
            case 6: // TYPE_REVIEW
                break;
            default:
                return false;
                break;
        }
        return true;
    }
}
